import { useState, useEffect } from "react";
import { Search, X } from "lucide-react";

const popularCities = [
  { name: "New York", icon: "/landing/location/newyork.png" },
  { name: "Los Angeles", icon: "/landing/location/california.png" },
  { name: "Houston", icon: "/landing/location/houston.png" },
  { name: "Miami", icon: "/landing/location/miami.png" },
  { name: "San Francisco", icon: "/landing/location/safransisco.png" },
  { name: "Las Vegas", icon: "/landing/location/vegas.png" },
  { name: "Boston", icon: "/landing/location/boston.png" },
  { name: "Chicago", icon: "/landing/location/newyork.png" },
];

const allCities = [
  { name: "Austin", state: "Texas", geohash: "9v6m" },
  { name: "Dallas", state: "Texas", geohash: "9vgc" },
  { name: "Houston", state: "Texas", geohash: "9vkf" },
  { name: "Los Angeles", state: "California", geohash: "9q5c" },
  { name: "New York", state: "New York", geohash: "dr5r" },
  { name: "Philadelphia", state: "Pennsylvania", geohash: "dr4u" },
  { name: "Miami", state: "Florida", geohash: "dhjv" },
  { name: "San Francisco", state: "California", geohash: "9q8y" },
  { name: "Chicago", state: "Illinois", geohash: "dp3w" },
  { name: "Boston", state: "Massachusetts", geohash: "drt2" },
  { name: "Seattle", state: "Washington", geohash: "c23n" },
  { name: "Denver", state: "Colorado", geohash: "9xj5" },
  { name: "Atlanta", state: "Georgia", geohash: "djy3" },
  { name: "Phoenix", state: "Arizona", geohash: "9tbh" },
  { name: "San Diego", state: "California", geohash: "9mud" },
  { name: "Las Vegas", state: "Nevada", geohash: "9qqj" },
  { name: "Detroit", state: "Michigan", geohash: "dph5" },
  { name: "Baltimore", state: "Maryland", geohash: "dqby" },
  { name: "Charlotte", state: "North Carolina", geohash: "dnq8" },
  { name: "Tampa", state: "Florida", geohash: "dhw5" },
  { name: "St. Louis", state: "Missouri", geohash: "9yzr" },
  { name: "New Orleans", state: "Louisiana", geohash: "9vqh" },
  { name: "Salt Lake City", state: "Utah", geohash: "9xmv" },
  { name: "Indianapolis", state: "Indiana", geohash: "dp84" },
  { name: "Cleveland", state: "Ohio", geohash: "dpm6" },
  { name: "Cincinnati", state: "Ohio", geohash: "dph8" },
  { name: "Kansas City", state: "Missouri", geohash: "9y6k" },
  { name: "Omaha", state: "Nebraska", geohash: "9z7d" },
  { name: "Oakland", state: "California", geohash: "9q9p" },
  { name: "Orlando", state: "Florida", geohash: "djv8" },
  { name: "Sacramento", state: "California", geohash: "9qcs" },
  { name: "Nashville", state: "Tennessee", geohash: "dn5b" },
  { name: "Milwaukee", state: "Wisconsin", geohash: "dp2k" },
  { name: "Raleigh", state: "North Carolina", geohash: "dnr4" },
  { name: "Memphis", state: "Tennessee", geohash: "dn5h" },
  { name: "Portland", state: "Oregon", geohash: "c20f" },
  { name: "Portland", state: "Maine", geohash: "drs5" },
  { name: "Albuquerque", state: "New Mexico", geohash: "9tcr" },
  { name: "Tulsa", state: "Oklahoma", geohash: "9ydd" },
  { name: "Fresno", state: "California", geohash: "9q5w" },
  { name: "Columbus", state: "Ohio", geohash: "dphs" },
  { name: "Wichita", state: "Kansas", geohash: "9y9k" },
  { name: "Pittsburgh", state: "Pennsylvania", geohash: "dppn" },
  { name: "Anchorage", state: "Alaska", geohash: "bfb4" },
  { name: "Honolulu", state: "Hawaii", geohash: "87gc" },
  { name: "Colorado Springs", state: "Colorado", geohash: "9xj4" },
  { name: "El Paso", state: "Texas", geohash: "9tcw" },
  { name: "Lexington", state: "Kentucky", geohash: "dn7z" },
  { name: "Reno", state: "Nevada", geohash: "9qqv" },
  { name: "Boise", state: "Idaho", geohash: "9rpu" },
  { name: "Spokane", state: "Washington", geohash: "c20n" },
  { name: "Baton Rouge", state: "Louisiana", geohash: "9vph" },
  { name: "Des Moines", state: "Iowa", geohash: "9z6w" },
  { name: "Fort Worth", state: "Texas", geohash: "9vgg" },
  { name: "Jacksonville", state: "Florida", geohash: "djuz" },
  { name: "Little Rock", state: "Arkansas", geohash: "9yqr" },
  { name: "Madison", state: "Wisconsin", geohash: "dp3s" },
  { name: "Richmond", state: "Virginia", geohash: "dq5v" },
  { name: "Sioux Falls", state: "South Dakota", geohash: "9zgy" },
  { name: "Springfield", state: "Illinois", geohash: "9yy6" },
  { name: "Tucson", state: "Arizona", geohash: "9t9v" },
  { name: "Bakersfield", state: "California", geohash: "9qhc" },
  { name: "Chattanooga", state: "Tennessee", geohash: "dn5p" },
  { name: "Durham", state: "North Carolina", geohash: "dnr5" },
  { name: "Fargo", state: "North Dakota", geohash: "c2j2" },
  { name: "Green Bay", state: "Wisconsin", geohash: "dp9x" },
  { name: "Harrisburg", state: "Pennsylvania", geohash: "dqcu" },
  { name: "Lubbock", state: "Texas", geohash: "9v6g" },
  { name: "Mobile", state: "Alabama", geohash: "djfy" },
  { name: "Modesto", state: "California", geohash: "9q7p" },
  { name: "Montgomery", state: "Alabama", geohash: "djff" },
  { name: "Newark", state: "New Jersey", geohash: "dr5x" },
  { name: "Norfolk", state: "Virginia", geohash: "dq1v" },
  { name: "Olympia", state: "Washington", geohash: "c23r" },
  { name: "Peoria", state: "Illinois", geohash: "dp46" },
  { name: "Rochester", state: "New York", geohash: "dqcj" },
  { name: "Salem", state: "Oregon", geohash: "c21g" },
  { name: "Santa Fe", state: "New Mexico", geohash: "9w7k" },
  { name: "Syracuse", state: "New York", geohash: "dqc7" },
  { name: "Topeka", state: "Kansas", geohash: "9yf0" },
  { name: "Wilmington", state: "Delaware", geohash: "dq8v" },
  { name: "Augusta", state: "Georgia", geohash: "drs8" },
  { name: "Bismarck", state: "North Dakota", geohash: "c8x6" },
  { name: "Cheyenne", state: "Wyoming", geohash: "9xh6" },
  { name: "Dover", state: "Delaware", geohash: "dr48" },
  { name: "Helena", state: "Montana", geohash: "c2mq" },
  { name: "Jefferson City", state: "Missouri", geohash: "9yze" },
  { name: "Lincoln", state: "Nebraska", geohash: "9z7g" },
  { name: "Montpelier", state: "Vermont", geohash: "dre4" },
  { name: "Tallahassee", state: "Florida", geohash: "dhk8" },
  { name: "Virginia Beach", state: "Virginia", geohash: "dq9c" },
  { name: "Providence", state: "Rhode Island", geohash: "drmj" },
  { name: "Fort Lauderdale", state: "Florida", geohash: "dhmq" },
  { name: "Riverside", state: "California", geohash: "9qh7" },
  { name: "Corpus Christi", state: "Texas", geohash: "9v6w" },
  { name: "Stockton", state: "California", geohash: "9q9x" },
  { name: "Santa Ana", state: "California", geohash: "9mup" },
  { name: "St. Paul", state: "Minnesota", geohash: "9zj7" },
  { name: "San Jose", state: "California", geohash: "9q9k" },
  { name: "Minneapolis", state: "Minnesota", geohash: "9zvx" },
];

export default function LocationPickerModal({ isOpen, onClose, onSelectLocation }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [filteredCities, setFilteredCities] = useState([]);

  useEffect(() => {
    if (selectedLetter) {
      const filtered = allCities.filter((city) =>
        city.name.toLowerCase().startsWith(selectedLetter.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  }, [selectedLetter]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = allCities.filter((city) =>
        city.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        city.state.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCities(filtered);
    } else {
      const filtered = allCities.filter((city) =>
        city.name.toLowerCase().startsWith(selectedLetter.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  }, [searchQuery, selectedLetter]);

  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          onSelectLocation({
            name: "Current Location",
            lat: latitude,
            lng: longitude,
          });
          onClose();
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Unable to get your current location. Please select a city from the list.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const handleCitySelect = (city) => {
    if (city.geohash) {
      localStorage.setItem("geohash", city.geohash);
      window.dispatchEvent(new CustomEvent("geohashChanged", { 
        detail: { geohash: city.geohash } 
      }));
    }
    onSelectLocation({ 
      name: city.name,
      state: city.state,
      geohash: city.geohash
    });
    onClose();
  };

  const handlePopularCitySelect = (city) => {
    const cityData = allCities.find(c => 
      c.name.toLowerCase() === city.name.toLowerCase()
    );
    
    if (cityData?.geohash) {
      localStorage.setItem("geohash", cityData.geohash);
      window.dispatchEvent(new CustomEvent("geohashChanged", { 
        detail: { geohash: cityData.geohash } 
      }));
      
      onSelectLocation({ 
        name: city.name,
        state: cityData.state,
        geohash: cityData.geohash
      });
    } else {
      onSelectLocation({ name: city.name });
    }
    onClose();
  };

  if (!isOpen) return null;

  const citiesPerColumn = Math.ceil(filteredCities.length / 5);
  const columns = [];
  for (let i = 0; i < 5; i++) {
    columns.push(filteredCities.slice(i * citiesPerColumn, (i + 1) * citiesPerColumn));
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Afacad:wght@400;500;600&display=swap');
        .afacad-font {
          font-family: 'Afacad', sans-serif;
        }
      `}</style>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 sm:p-6 border-b relative">
          <h2 className="text-center flex-1 afacad-font font-bold" style={{ 
            fontSize: 'clamp(18px, 1.56vw, 24px)',
            color: '#000000'
          }}>Select Location</h2>
          <button
            onClick={onClose}
            className="absolute right-4 sm:right-6 text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 p-4 sm:p-6">
          <div className="relative mb-4">
            <Search className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 sm:w-5 sm:h-5" />
            <input
              type="text"
              placeholder="Search city, area or locality"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent afacad-font"
              style={{ 
                fontSize: 'clamp(14px, 1.21vw, 16px)',
                fontFamily: 'Afacad, sans-serif'
              }}
            />
          </div>

          <div className="flex justify-center mb-6">
            <button
              onClick={handleUseCurrentLocation}
              className="flex items-center justify-center gap-3 px-4 py-2.5 sm:py-3 rounded-lg transition-colors"
              style={{ 
                backgroundColor: '#FFFFFF',
                border: '1px solid #D1D5DB',
                width: 'fit-content'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#F9FAFB';
                e.currentTarget.style.borderColor = '#7B189F';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFFFFF';
                e.currentTarget.style.borderColor = '#D1D5DB';
              }}
            >
              <img
                src="/landing/location/current-loaction.png"
                alt="Current Location"
                className="w-5 h-5 sm:w-6 sm:h-6"
              />
              <span className="afacad-font text-gray-800 font-medium" style={{ 
                fontSize: 'clamp(14px, 1.21vw, 16px)'
              }}>
                Use Current Location
              </span>
            </button>
          </div>

          <div className="mb-8">
            <h3 className="afacad-font font-bold text-gray-900 mb-4" style={{ 
              fontSize: 'clamp(16px, 1.39vw, 20px)'
            }}>Popular Cities</h3>
            <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 gap-3 sm:gap-4">
              {popularCities.map((city) => (
                <button
                  key={city.name}
                  onClick={() => handlePopularCitySelect(city)}
                  className="flex flex-col items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer"
                >
                  <img
                    src={city.icon}
                    alt={city.name}
                    className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-contain"
                  />
                  <span className="afacad-font text-gray-700 text-center font-medium" style={{ 
                    fontSize: 'clamp(12px, 1.04vw, 14px)'
                  }}>
                    {city.name}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="afacad-font font-bold text-gray-900 mb-4" style={{ 
              fontSize: 'clamp(16px, 1.39vw, 20px)'
            }}>All Cities            </h3>

            <div className="flex flex-wrap gap-1 sm:gap-2 mb-4 overflow-x-auto pb-2">
              {Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)).map((letter) => (
                <button
                  key={letter}
                  onClick={() => {
                    setSelectedLetter(letter);
                    setSearchQuery("");
                  }}
                  className={`px-2 sm:px-3 py-1 sm:py-1.5 rounded afacad-font font-medium transition-colors ${
                    selectedLetter === letter
                      ? "bg-[#7B189F] text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                  style={{ 
                    fontSize: 'clamp(12px, 1.04vw, 14px)'
                  }}
                >
                  {letter}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3">
              {filteredCities.map((city) => (
                <button
                  key={`${city.name}-${city.state}`}
                  onClick={() => handleCitySelect(city)}
                  className="text-left px-2 sm:px-3 py-1.5 sm:py-2 rounded transition-colors afacad-font"
                  style={{ 
                    fontSize: 'clamp(12px, 1.04vw, 14px)',
                    color: '#374151'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#7B189F1A';
                    e.currentTarget.style.color = '#7B189F';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#374151';
                  }}
                >
                  {city.name}
                </button>
              ))}
            </div>

            {filteredCities.length === 0 && (
              <div className="text-center py-8 text-gray-500 text-sm sm:text-base">
                No cities found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

